import { RateCardZone } from "services/BillingEngineService/interfaces";
import { useQuery } from "react-query-legacy";
import { BillingEngineService } from "services";

function useCurrentVersion(activeZone?: RateCardZone) {
  const getVersionParams: () => any = () => {
    if (activeZone) {
      return activeZone?.latestRateCardZoneVersionId
        ? [
            "version",
            {
              rateCardId: activeZone.rateCardId,
              rateCardZoneId: activeZone.id,
              versionId: activeZone.latestRateCardZoneVersionId,
            },
          ]
        : false;
    }
    return false;
  };

  // Fetch current version
  const query = useQuery(getVersionParams, BillingEngineService.getRateCardZoneVersion, {
    refetchOnWindowFocus: false,
  });

  return query;
}

export { useCurrentVersion };
